import React from "react";

const RecordDotSvgIcon = ({ width = 20, height = 20, style }) => {
  return (
    <div style={{ display: "inline-block", ...style }}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Outer Circle */}
        <path
          d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
          fill="#EEEEEE"
        />
        {/* Inner Circle (Cross) */}
        <path
          d="M10 13.5714C11.9724 13.5714 13.5714 11.9724 13.5714 10C13.5714 8.02755 11.9724 6.42857 10 6.42857C8.02755 6.42857 6.42857 8.02755 6.42857 10C6.42857 11.9724 8.02755 13.5714 10 13.5714Z"
          fill="#F44336"
        />
      </svg>
    </div>
  );
};

export default RecordDotSvgIcon;
